'use client';

export function PreferencesTabContent() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-md font-medium tracking-tight">Preferences</h1>
      </div>
      <p className="text-muted-foreground text-sm">
        Behavior and appearance settings. Coming soon.
      </p>
    </div>
  );
}
